<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :title="title"
      id="constructionSimulation"
      :close="close"
      class="newModelPosition hierarchy1"
    >
      <template slot="head">
        <div class="head-operate">
          <el-button type="primary" @click="modelConstructionSimulationAdd">
            <i class="el-icon-zengjia"></i> 新增施工方案
          </el-button>
        </div>
      </template>
    </MapModal>
    <Programme
      v-if="ifProgramme"
      :title="programmeTitle"
      :sceneId="sceneId"
      :programmeData="programmeData"
      :getConstructionSimulationList="getConstructionSimulationList"
      ref="programme"
      @close="closeProgramme"
    ></Programme>
    <TimeBlock
      v-if="ifTimeBlock"
      :title="timeBlockTitle"
      :sceneId="sceneId"
      :timeBlockData="timeBlockData"
      :getConstructionSimulationList="getConstructionSimulationList"
      ref="timeBlock"
      @close="closeTimeBlock"
    ></TimeBlock>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const Animation = () => import("@/components/tables/animation/Index.vue");
const Programme = () =>
  import("@/components/tables/animation/constructionSimulation/Programme.vue");
const TimeBlock = () =>
  import("@/components/tables/animation/constructionSimulation/TimeBlock.vue");
import * as mapWork from "@/components/tables/animation/map.js";
import * as constructionSimulationMapWork from "@/components/tables/animation/constructionSimulation/map.js";
import {
  detailBimConstructSimGrouping,
  deleteBimConstructSimGrouping,
  deleteBimConstructSimDetail,
} from "@/api/api";
export default {
  name: "constructionSimulation",
  components: { MapModal, Animation, Programme, TimeBlock },
  data() {
    return {
      title: "施工模拟",
      modalNode: {
        constructionSimulation: {
          show: true, // 默认展示
          loading: false, // 加载loading
          width: "380px", // 宽度配置 默认450px
          height: `${window.screen.height - 200 - 110}px`, // 配置模态框中心高度
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "shpTree", // id和ref使用的同一个
            // name: "title", // 树的展示字段 默认name
            expand: true,
            expandClick: true,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            search: {
              keywords: "title", // 搜素配置关键字 默认是name
            },
            nodeClick: this.nodeClick,
          },
        },
      },
      ifAnimation: false,
      ifProgramme: false,
      ifTimeBlock: false,
      programmeTitle: "add",
      timeBlockTitle: "add",
      // 时区数据
      // timeBlockData: null,

      programmeData: {
        cameraView: null,
        name: null,
        totalTime: null,
        speed: 1,
      },

      timeBlockData: {
        parentTotalTime: null,
        groupId: null,
        totalTime: null,
        stype: true,
        model: null,
        component: null,
      },
    };
  },
  computed: {},
  props: {
    close: {
      type: Function,
    },
    sceneId: {
      type: Number,
    },
    isShow: {
      type: Boolean,
    },
  },
  watch: {},
  filters: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  methods: {
    nodeClick() {},
    modelConstructionSimulationAdd() {
      if (this.sceneId == 0) {
        this.$message({
          message: "请先选择一个场景",
          type: "warning",
          duration: 2000,
        });
        return false;
      }
      this.programmeTitle = "add";
      this.programmeData = {
        cameraView: null,
        name: null,
        totalTime: null,
        speed: 1,
      };
      this.ifProgramme = true;
      this.ifTimeBlock = false;
    },

    modelConstructionSimulationEdit(e) {
      this.programmeTitle = "edit";
      console.log(e);
      // e.startTime.split(" ")[1]
      this.programmeData = {
        cameraView: e.viewGraphic,
        name: e.name,
        id: e.id,
        totalTime: [e.startTime, e.endTime],
        speed: 1,
      };
      this.ifProgramme = true;
      this.ifTimeBlock = false;
    },

    modelConstructionSimulationDelete(e) {
      deleteBimConstructSimGrouping({
        sceneId: this.sceneId,
        id: e.id,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.$notify({
              title: "删除成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.getConstructionSimulationList();
          } else {
            this.$notify({
              title: "删除失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((res) => {
          this.$notify({
            title: "删除失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },

    timeBlockAdd(e) {
      console.log(e);
      this.timeBlockTitle = "add";
      this.ifProgramme = false;
      this.ifTimeBlock = true;
      this.timeBlockData.parentTotalTime = [e.startTime, e.endTime];
      this.timeBlockData.groupId = e.id;
    },
    timeBlockPlay(e) {
      console.log(e);
      let animation = {
        groups: [
          {
            content: "施工模拟",
            id: "constructionSimulation",
          },
        ],
        animationData: [],
        initCustomDate: "",
        maxTime: "",
        programmeSimulationShow: false,
        loading: false,
      };
      animation.initCustomDate = e.startTime;
      animation.maxTime = e.endTime;
      e.children.forEach((item) => {
        let end = item.endTime;
        animation.animationData.push({
          content: `${item.name}`,
          group: "constructionSimulation",
          id: item.id,
          start: item.startTime,
          end,
          screenplay: [
            {
              screenplayType: "special", //复杂操作
              type: "animation", //动画操作
              executionProperty: "componentDyeing", //动画操作 施工模拟方法
              screenplayId: item.id,
              property: {
                id: item.id,
                type: item.isShow ? "show" : "hide", // 是隐藏还是显示操作
                component:
                  typeof item.units == "string"
                    ? JSON.parse(item.units)
                    : item.units, // 构件数组
                screenplayId: item.modelId,
              },
            },
          ],
        });
      });
      console.log(animation);
      this.$emit("initAnimation", animation);
    },

    timeBlockEdit(e) {
      console.log(e);
      this.timeBlockTitle = "edit";
      this.ifProgramme = false;
      this.ifTimeBlock = true;
      this.timeBlockData.id = e.id;
      this.timeBlockData.parentTotalTime = [e.parentStartTime, e.parentEndTime];
      this.timeBlockData.groupId = e.groupId;
      this.timeBlockData.totalTime = [e.startTime, e.endTime];
      this.timeBlockData.model = e.modelId;
      this.timeBlockData.stype = e.isShow;
      this.timeBlockData.component = JSON.parse(e.units);
      // this.timeBlockData.
    },

    timeBlockDelete(e) {
      deleteBimConstructSimDetail({
        sceneId: this.sceneId,
        id: e.id,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.$notify({
              title: "删除成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.getConstructionSimulationList();
          } else {
            this.$notify({
              title: "删除失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((res) => {
          this.$notify({
            title: "删除失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    closeProgramme() {
      this.ifProgramme = false;
    },
    closeTimeBlock() {
      this.ifTimeBlock = false;
    },
    getConstructionSimulationList() {
      this.ifProgramme = false;
      this.ifTimeBlock = false;
      detailBimConstructSimGrouping({
        sceneId: this.sceneId,
      })
        .then((res) => {
          let { code, data } = res.data;
          let timeBlockPlay = [];
          if (code == 200 || code == 204) {
            data.forEach((item) => {
              if (item.children.length > 0) {
                timeBlockPlay = [
                  {
                    i_icon: "el-icon-video-play",
                    click: this.timeBlockPlay,
                  },
                ];
              }
              item.operate = [
                ...timeBlockPlay,
                {
                  i_icon: "small-operation-btn el-icon-plus",
                  click: this.timeBlockAdd,
                },
                {
                  i_icon: "small-operation-btn el-icon-edit",
                  click: this.modelConstructionSimulationEdit,
                },
                {
                  i_icon: "small-operation-btn el-icon-delete",
                  click: this.modelConstructionSimulationDelete,
                },
              ];
              item.children.forEach((e, index) => {
                e.name = `${item.name}-时间区域${index + 1}`;
                e.operate = [
                  {
                    i_icon: "small-operation-btn el-icon-edit",
                    click: this.timeBlockEdit,
                  },
                  {
                    i_icon: "small-operation-btn el-icon-delete",
                    click: this.timeBlockDelete,
                  },
                ];
              });
            });
            this.modalNode.constructionSimulation.content.treeDataJson = data;
            console.log("getAnimation", data);
            mapWork.getAnimation(data);
            // constructionSimulationMapWork.init();
          } else {
            this.$notify({
              title: "添加失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((res) => {
          this.$notify({
            title: "添加失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    init() {
      this.getConstructionSimulationList();
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.init();
  },
  watch: {
    isShow(newV) {
      if (newV && this.sceneId && this.sceneId != 0) {
        this.getConstructionSimulationList();
      }
    },
  },
  destroyed() {
    this.ifProgramme = false;
    this.ifTimeBlock = false;
    this.ifAnimation = false;
  },
};
</script>
<style lang="scss" scoped></style>
